// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"088ce796","306":"3b15d8a7","364":"938dd2af","366":"ed7a4e73","503":"0004cbd2","635":"92570267","730":"ddde97e5","736":"1e30fb05","785":"ff9f19a0","825":"bf4265f4","949":"f4db75ba"}[chunkId] + ".chunk.js";
};